var SCM = SCM || {};

(function (aft, $, iou, bc) {
    var widgetWrap = $('#ArticleFullTextWrap');
    var hasAccess = false;

    if (widgetWrap && widgetWrap.attr('data-userHasAccess')) {
        hasAccess = widgetWrap.attr('data-userHasAccess').toLowerCase() === 'true';
    }

    // for un-authenticated users, replace reveal-modal links (such as links to references) with spans
    // since the target of the link is likely to be missing when the user is only viewing an abstract
    aft.replaceContentLinks = function() {
        if (!hasAccess) {
            var contentLinks = widgetWrap.find('a[data-reveal-id]');
            contentLinks.each(function () {
                $(this).replaceWith(function () {
                    var anchorHtml = this.innerHTML;
                    return '<span>' + anchorHtml + '</span>';
                });
            });
        }
    };
    // initialize functionality
    aft.init = function () {
        aft.replaceContentLinks();
        bc.init();
        iou.init();
    };
})(SCM.ArticleFulltext = SCM.ArticleFulltext || {}, jQuery, SCM.InstitutionOpenUrl, SCM.Utilities.Brightcove);
